import type { Lang } from '../routes';
import type { PageKey } from '../routes';

export const navLabels: Record<Lang, Record<Exclude<PageKey, 'nieuwsbrief'>, string>> = {
  nl: {
    statement: 'Artist statement',
    recent: 'Perpetual Plexus',
    nieuwwerk: 'Home',
    visualisatie: 'Visualisatie',
    media: 'Media',
    bio: 'CV',
    contact: 'Contact',
  },
  en: {
    statement: 'Artist statement',
    recent: 'Network',
    nieuwwerk: 'Home',
    visualisatie: 'Visualization',
    media: 'Media',
    bio: 'CV',
    contact: 'Contact',
  },
};

/** Order of the main menu. */
export const navOrder: Exclude<PageKey, 'nieuwsbrief'>[] = [
  'nieuwwerk',
  'statement',
  'recent',
  'visualisatie',
  'bio',
  'media',
  'contact',
];

export const ui = {
  nl: {
    openMenu: 'Menu openen',
    closeMenu: 'Menu sluiten',
    switchLanguage: 'Switch to English',
    switchToDark: 'Donker thema',
    switchToLight: 'Licht thema',
    loading: 'Laden…',
    soldOut: 'Verkocht',
    onRequest: 'Prijs op aanvraag',
    backToOverview: '← Terug naar overzicht',
    interested: 'Interesse in dit werk',
    inquiryIntro: 'Laat je gegevens achter en ik neem persoonlijk contact met je op.',
    name: 'Naam',
    email: 'E-mail',
    message: 'Bericht',
    send: 'Versturen',
    sending: 'Versturen…',
    sent: 'Bedankt! Je bericht is verstuurd.',
    sendFailed: 'Versturen mislukt. Probeer het later nog eens.',
    notFound: 'Dit werk bestaat niet (meer).',
    noWorks: 'Er is op dit moment geen nieuw werk beschikbaar.',
    materials: 'Materialen',
    dimensions: 'Afmetingen',
    year: 'Jaar',
    newsletterPlaceholder: 'Je e-mailadres',
    newsletterButton: 'Inschrijven',
    newsletterSending: 'Inschrijven…',
    newsletterSuccess: 'Bedankt voor je inschrijving!',
    newsletterError: 'Inschrijven mislukt. Probeer het later nog eens.',
    newsletterInvalidEmail: 'Voer een geldig e-mailadres in.',
    newsletterFooterTitle: 'Blijf op de hoogte',
    newsletterFooterText: 'Schrijf je in voor updates over nieuw werk en projecten.',
  },
  en: {
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    switchLanguage: 'Bekijk in het Nederlands',
    switchToDark: 'Dark theme',
    switchToLight: 'Light theme',
    loading: 'Loading…',
    soldOut: 'Sold',
    onRequest: 'Price on request',
    backToOverview: '← Back to overview',
    interested: 'Interested in this work',
    inquiryIntro: 'Leave your details and I will get back to you personally.',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    send: 'Send',
    sending: 'Sending…',
    sent: 'Thank you! Your message has been sent.',
    sendFailed: 'Sending failed. Please try again later.',
    notFound: 'This work no longer exists.',
    noWorks: 'There is no new work available at the moment.',
    materials: 'Materials',
    dimensions: 'Dimensions',
    year: 'Year',
    newsletterPlaceholder: 'Your email address',
    newsletterButton: 'Subscribe',
    newsletterSending: 'Subscribing…',
    newsletterSuccess: 'Thank you for subscribing!',
    newsletterError: 'Subscription failed. Please try again later.',
    newsletterInvalidEmail: 'Please enter a valid email address.',
    newsletterFooterTitle: 'Stay in the loop',
    newsletterFooterText: 'Subscribe for updates on new work and projects.',
  },
} as const;
